import { FC } from "react";

import { Blocks, BlocksProps } from "@builder.io/sdk-react";

type EditableZoneProps = Pick<BlocksProps, "parent" | "blocks"> & {
  blockPropPathSegments: string[] | string;
};

export const EditableZone: FC<EditableZoneProps> = ({
  blockPropPathSegments,
  ...restProps
}) => {
  const path = createBuilderBlockPath(
    typeof blockPropPathSegments === "string"
      ? [blockPropPathSegments]
      : blockPropPathSegments
  );

  return <Blocks {...restProps} path={path} />;
};

const createBuilderBlockPath = (blockPropPath: string[]) =>
  `component.options.${blockPropPath.join(".")}`;
